// View Keys 
export default {
    reportsModalExtraTime_Title: 'Su solicitud puede tomar más tiempo',
    reportsModalExtraTime_inputText: "El informe que intenta ejecutar puede tardar más en cargarse. Le notificaremos cuando esté listo para verlo en su navegador. Mientras tanto, podemos enviárselo en formato PDF o CSV si lo desea",
    reportsModalExtraTime_sendPDF: "Enviar PDF",
    reportsModalExtraTime_sendCSV: "Enviar CSV",
    reportsModalExtraTime_Illwait: "Esperaré",
    reportsModalExtraTime_email: "Correo",
  };